export const energyData = [
    {
        id: 1,
        group: "Население и приравненные к ним, за исключением населения и потребителей, указанных в пунктах 2 и 3",
        measure: "руб./кВт.ч",
        price1: "8,25",
        price2: "8,38"
    },

    {
        id: 1.2,
        group: "Население и приравненные к ним. за исключением населения и потребителей, указанных в п.2 и 3 по зонам суток(дневная/ночная).",
        measure: "руб./кВт.ч",
        price1: "10,14/4,36",
        price2: "10,30/4,43"
    },

    {
        id: 2.1,
        group: "Население, проживающее в городских населенных пунктах в домах, оборудованных электрическими плитами",
        measure: "руб./кВт.ч",
        price1: "6,60",
        price2: "6,70"
    },

     {
        id: 2.2,
        group: "Население, проживающее в городских населенных пунктах в домах, оборудованных электрическими плитами по зонам суток.(дневная/ночная).",
        measure: "руб./кВт.ч",
        price1: "8,11/3,49",
        price2: "8,24/3,54"
    },

    {
        id: 3.1,
        group: "Население, проживающее в сельских населенных пунктах",
        measure: "руб./кВт.ч",
        price1: "6,19",
        price2: "6,29"
    },

    {
        id: 3.2,
        group: "Население, проживающее в сельских населенных пунктах по зонам суток(дневная/ночная).",
        measure: "руб./кВт.ч",
        price1: "7,61/3,27",
        price2: "7,73/3,32"
    }

    ]
